/**
 * Incoterms Constants
 *
 * International Commercial Terms (Incoterms) 2020
 * Standard trade terms published by the International Chamber of Commerce (ICC)
 */

export interface Incoterm {
  /** Incoterm code (e.g., "EXW", "FOB") */
  code: string;
  /** Full name of the incoterm */
  name: string;
  /** Brief description */
  description: string;
}

/**
 * All Incoterms 2020
 */
export const INCOTERMS: Incoterm[] = [
  {
    code: 'EXW',
    name: 'Ex Works',
    description: 'Seller makes goods available at their premises',
  },
  {
    code: 'FCA',
    name: 'Free Carrier',
    description: 'Seller delivers goods to carrier at named place',
  },
  {
    code: 'FAS',
    name: 'Free Alongside Ship',
    description: 'Seller delivers goods alongside the vessel',
  },
  {
    code: 'FOB',
    name: 'Free On Board',
    description: 'Seller delivers goods on board the vessel',
  },
  {
    code: 'CFR',
    name: 'Cost and Freight',
    description: 'Seller pays costs and freight to destination port',
  },
  {
    code: 'CIF',
    name: 'Cost, Insurance and Freight',
    description: 'Seller pays costs, insurance and freight to destination port',
  },
  {
    code: 'CPT',
    name: 'Carriage Paid To',
    description: 'Seller pays carriage to named destination',
  },
  {
    code: 'CIP',
    name: 'Carriage and Insurance Paid To',
    description: 'Seller pays carriage and insurance to named destination',
  },
  {
    code: 'DAP',
    name: 'Delivered at Place',
    description: 'Seller delivers goods at named destination',
  },
  {
    code: 'DPU',
    name: 'Delivered at Place Unloaded',
    description: 'Seller delivers goods unloaded at named destination',
  },
  {
    code: 'DDP',
    name: 'Delivered Duty Paid',
    description: 'Seller delivers goods cleared for import at destination',
  },
];

/**
 * Incoterm codes for simple dropdown selection
 */
export const INCOTERM_CODES = INCOTERMS.map((i) => i.code);

/**
 * Incoterms formatted for Select component options
 */
export const incotermSelectOptions = INCOTERMS.map((incoterm) => ({
  value: incoterm.code,
  label: incoterm.code,
  description: incoterm.name,
}));
